module.exports = __webpack_public_path__ + "static/research_card_img2@2x-16fc3df000f8413165ee280f6bf1068b.jpg";